import { createTypeAnnotationBasedOnTypeof } from '@babel/types'
import {
  Alert,
  AlertIcon,
  Button,
  chakra,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HTMLChakraProps,
  Input,
  Stack,
} from '@chakra-ui/react'
import { createOrUpdateTeam } from '@utils/api/teams.service'
import { useUser } from '@utils/useUser'
import router from 'next/router'
import * as React from 'react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { PasswordField } from './ui/PasswordField'

export const RegisterForm = (props: HTMLChakraProps<'form'>) => {
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm()
  const { signUp } = useUser()
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined)

  const onFormSubmit = async (formData: { email: string; password: string; full_name: string }) => {
    const { email, password, full_name } = formData

    const { error } = await signUp({ password, email }, { data: { full_name } })

    if (error) return setErrorMessage(error?.message)

    if (!error) {
      router.push('/dashboard')
    }
  }

  return (
    <chakra.form onSubmit={handleSubmit(onFormSubmit)} {...props}>
      {errorMessage && (
        <Alert my={4} borderRadius={5} status="error">
          <AlertIcon />
          {errorMessage}
        </Alert>
      )}
      <Stack spacing="6">
        <FormControl id="full_name" isInvalid={errors.name}>
          <FormLabel>Full Name</FormLabel>
          <Input
            type="full_name"
            autoComplete="full_name"
            required
            {...register('full_name', {
              required: 'This is required',
            })}
          />
          <FormErrorMessage>{errors.full_name && errors.full_name}</FormErrorMessage>
        </FormControl>
        <FormControl id="email" isInvalid={errors.name}>
          <FormLabel>Email address</FormLabel>
          <Input
            type="email"
            autoComplete="email"
            required
            {...register('email', {
              required: 'This is required',
            })}
          />
          <FormErrorMessage>{errors.email && errors.email.message}</FormErrorMessage>
        </FormControl>
        <PasswordField register={register} errors={errors} />

        <Button type="submit" colorScheme="teal" size="lg" fontSize="md" isLoading={isSubmitting}>
          Sign up
        </Button>
      </Stack>
    </chakra.form>
  )
}
